import { VFC } from 'react'
import { _profilehrborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { CustomLinkify } from '../Linkify'
import { Label, LabelsContent, Section, sectionBodyStyle } from './styles'
import { ProfilePreviewProps } from './types'

export const ResponsibilitiesSection: VFC<ProfilePreviewProps> = ({
  user: {
    profile: { position },
    responsibilities: { domains, features, message },
  },
}) => {
  if (!(position || domains.length > 0 || features.length > 0 || message))
    return <></>
  return (
    <Section>
      <h3>決裁者情報</h3>
      <ResposibilityDiv>
        {position && (
          <div>
            <h4>役職</h4>
            <p>
              <Label>{position}</Label>
            </p>
          </div>
        )}
        {domains.length > 0 && (
          <div>
            <h4>決裁領域</h4>
            <LabelsDiv>
              <LabelsContent>
                {domains.map((domain) => (
                  <Label key={domain}>{domain}</Label>
                ))}
              </LabelsContent>
            </LabelsDiv>
          </div>
        )}
        {features.length > 0 && (
          <div>
            <h4>特徴</h4>
            <LabelsDiv>
              {features.map((feature) => (
                <Label key={feature}>{feature}</Label>
              ))}
            </LabelsDiv>
          </div>
        )}
        {message && (
          <>
            <h4>自己紹介</h4>
            <CustomLinkify>{message}</CustomLinkify>
          </>
        )}
      </ResposibilityDiv>
    </Section>
  )
}

const ResposibilityDiv = styled.div`
  ${sectionBodyStyle};
  h4 {
    font-weight: ${fontWeightBold};
  }
  > div {
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 16px 0;
    border-bottom: 2px solid ${_profilehrborder};
    :first-child {
      margin-top: 0;
    }
    h4 {
      width: 22%;
      white-space: nowrap;
      font-weight: ${fontWeightBold};
    }
    > p,
    div {
      flex: 1;
    }
  }
  > h4 {
    margin-top: 20px;
    padding: 16px 0;
    border-bottom: 2px solid ${_profilehrborder};
  }
  > p {
    padding: 16px 0;
  }
`
const LabelsDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
`
